import { IMenuItem } from "../types/menuItems"
import { IUserDetail } from "../types/user"
import { projectSubMenuItems } from "../views/main/constants/menuItems"
import { IProject } from "../views/project/types/project"
import { checkAdminStatus, checkRole } from "./checkRole"

/**
 * Get project submenu by rights
 * @param user
 * @param project
 * @return IMenuItem[]
 */

const getCorrectSubmenuItem = (name: string, user: IUserDetail | null, role: number[], items: IMenuItem[]) => {
  let _projectSubMenuItems: IMenuItem[] = [...items]
  if (user && checkRole(user, role)) {
    const _submenuItem = projectSubMenuItems.find(i => i.name === name)
    if (_submenuItem) {
      _projectSubMenuItems = [..._projectSubMenuItems, ...[_submenuItem]]
    }
  }
  return _projectSubMenuItems
}

export const projectSubmenu = (user: IUserDetail | null, project: IProject): IMenuItem[] => {
  const _internalProjectSubMenuItems = projectSubMenuItems.filter(i => i.name !== 'Milestones')
    .map(i => i.name === 'Budget' ? i = { name: 'Expenditures', path: '/expenditures', parentPath: '/projects', active: false, rights: [16] } : i)
    .filter(i => i.name !== 'Accounting')
  let _projectSubMenuItems: IMenuItem[] = []
  if (user && checkAdminStatus(user, project)) {
    _projectSubMenuItems = projectSubMenuItems
  } else {
    _projectSubMenuItems = getCorrectSubmenuItem('Activities', user, [], [])
    _projectSubMenuItems = getCorrectSubmenuItem('Budget', user, [16], _projectSubMenuItems)
    if (project.type === 'internal') {
      _projectSubMenuItems = getCorrectSubmenuItem('Expenditures', user, [16], _projectSubMenuItems)
    }
    _projectSubMenuItems = getCorrectSubmenuItem('Milestones', user, [28], _projectSubMenuItems)
    _projectSubMenuItems = getCorrectSubmenuItem('Insights', user, [21], _projectSubMenuItems)
    _projectSubMenuItems = getCorrectSubmenuItem('Accounting', user, [19], _projectSubMenuItems)
    _projectSubMenuItems = getCorrectSubmenuItem('Settings', user, [14], _projectSubMenuItems)
  }
  if (!project.accounting && project.type !== 'service_provider') {
    _projectSubMenuItems = _projectSubMenuItems.filter(i => i.name !== 'Accounting')
  }
  if (project.type !== 'service_provider') {
    _projectSubMenuItems = _projectSubMenuItems.filter(i => i.name !== 'Milestones')
  }
  if (project.type === 'internal') {
    _projectSubMenuItems = user && checkAdminStatus(user, project)
      ? _internalProjectSubMenuItems
      : _internalProjectSubMenuItems.filter(i => i.name !== 'Dashboard')
  }
  return _projectSubMenuItems
}
